import styled from "styled-components";

export const StyledArticleVerticalNavigationWrapper = styled.div`
  margin-top: 15px;
  overflow-x: hidden !important;
  overflow-y: auto !important;
`

export const StyledArticleMainSubjectsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 15px 0;
`

export const StyledArticleMainSubjectListItem = styled.li`
  border-left: 2px solid
    ${({ isActive }) => (isActive ? "#C4B180" : "rgba(196, 177, 128, 0.60)")};
  color: ${({ isActive }) => (isActive ? "#86723E" : "#252525")};
  padding: 15px;
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.7px;
`